
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"compararPreciosProveedor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proveedorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"depositoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ComparacionPrecioRowInput"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compararPreciosProveedor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proveedorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proveedorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"depositoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"depositoId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rows"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producto"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"codigoBarras"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marca"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"modelo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tamanio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tamanio"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"precio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ivaPorcentaje"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"porcentajeSobreCosto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipoRedondeo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"codigoBarrasProveedor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreArchivo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioCompraNuevo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descuentoNuevo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioNuevoNeto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioCompraActual"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descuentoActual"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioActualNeto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioVentaActual"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioVentaNuevo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diferenciaPorcentaje"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recomendado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metodoMatch"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":700}};
    doc.loc.source = {"body":"query compararPreciosProveedor($proveedorId: ID!, $depositoId: ID!, $rows: [ComparacionPrecioRowInput!]!) {\n  compararPreciosProveedor(proveedorId: $proveedorId, depositoId: $depositoId, rows: $rows) {\n    producto {\n      id\n      nombre\n      codigoBarras\n      marca { id nombre }\n      modelo { id nombre }\n      tamanio { id tamanio }\n      precio\n      ivaPorcentaje\n      porcentajeSobreCosto\n      tipoRedondeo\n    }\n    codigoBarrasProveedor\n    nombreArchivo\n    precioCompraNuevo\n    descuentoNuevo\n    precioNuevoNeto\n    precioCompraActual\n    descuentoActual\n    precioActualNeto\n    precioVentaActual\n    precioVentaNuevo\n    diferenciaPorcentaje\n    recomendado\n    metodoMatch\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["compararPreciosProveedor"] = oneQuery(doc, "compararPreciosProveedor");
        
